<template>
    <div>
        <a id="bypass-main" href="#main-content">Skip to main content</a>
        <Header class="head"/>
        <main id="main-content">
            <router-view/>
        </main>
        <Footer />
    </div>
</template>

<style></style>

<script>
import Footer from '@/components/Footer.vue'
import Header from '@/components/Header.vue'

export default {
    components: {
        Footer,
        Header
    },
    updated() {
        if (!this.$route.hash) {
            document.querySelector('html').scrollTop = 0;
        }
    },
    mounted () {
        document.querySelector('html').setAttribute('lang', this.$i18n.locale);
    }
}
</script>

<style scoped>
#bypass-main {
    opacity: 0;
    position: absolute;
    margin: 0;
    padding: 0;
    left: 0;
    top: 0;
    font-size: 0;
    font-family: Arial;
}

#bypass-main:focus {
    z-index: 999;
    opacity: 1;
    font-size: 12px;
    color: #fff;
    padding: 5px 10px;
    display: block;
    background: #4a4a4a;
}

.head{
    z-index: 10;
}
</style>